// extracted by mini-css-extract-plugin
export var container = "_js-0";
export var dotAnimation = "_js-2";
export var dotsLoading = "_js-1";